import loader from "@monaco-editor/loader";

import React, { FunctionComponentElement, useState } from "react";
import { Button } from "primereact/button";
import { CodeEditor } from "../code/CodeEditor";
import { NodeInputProps } from "./index";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { ErrorDefaultValueWidget } from "../error/errorDefaultValueWidget";
import { useDispatch } from "react-redux";
import { setToast } from "../../app/appSlice";

loader.config({ paths: { vs: "/vs" } });
export const CodeInput = ({
  defaultValue,
  value,
  onChange,
  type,
  disabled
}: NodeInputProps): FunctionComponentElement<NodeInputProps> => {
  const regex = new RegExp(/(.*)\[(.*)\]/);
  const [dialogVisibility, setDialogVisibility] = useState<boolean>(false);

  const [incorrectDefaultValue, setIncorrectDefaultValue] =
  useState<boolean>(false);

  const dispatch = useDispatch()

  const verifyTypeCode = (value: any) => {
    if (typeof value === "string") return true;
    return false;
  };

  const verifyTypeCodeParsed = (value: any) => {
    if(typeof value === "string") return false
    try {
      const jsonString = JSON.stringify(value);
      JSON.parse(jsonString);
      return true
    } catch {
      return false
    }
  
  };

  const [codeEditorValue, setCodeEditorValue] = useState<string>(
    () => {
      const currentValue = value ? value : defaultValue
      if (currentValue) {
        if(type === "codeparsed") {
          if (verifyTypeCodeParsed(currentValue)) return JSON.stringify(currentValue);
          else setIncorrectDefaultValue(true);
        } else {
          if (verifyTypeCode(currentValue)) return currentValue;
          else setIncorrectDefaultValue(true);
        }
      }
      return "";
    }
  );
  const [unsaved, setUnsaved] = useState<boolean>(false);
  const [lang] = useState<string>(() => {
    const m = type.match(regex);
    if (m) {
      if (m.length > 1) {
        return m[2].toLowerCase();
      }
    }
    return "json";
  });

  const footer = () => {
    return (
      <div className="flex justify-content-end mt-1">
        <Button
          label={"ANNULER"}
          type="button"
          onClick={() => {
            if (unsaved) {
              confirmDialog();
            } else {
              setDialogVisibility(false);
              setUnsaved(false);
            }
          }}
          className="m-2 p-button-outlined p-button-sm"
        />

        <Button
          label={"SAUVEGARDER"}
          type="button"
          onClick={() => {
            saveData()
          }}
          className="m-2 p-button-sm"
        />
      </div>
    );
  };

  const header = () => {
    return (
      <div className="flex justify-content-between">
        <div>Editer ({lang})</div>

        <div>
          {unsaved && (
            <div className="mr-2">
              <Message
                text="Des changements n'ont pas été enregistrés"
                severity="info"
                icon="pi pi-save"
                className="mr-1"
                style={{ height: "0.7rem" }}
              ></Message>
            </div>
          )}
        </div>
      </div>
    );
  };

  const confirmDialog = () => {
    if (
      window.confirm(
        "Etes vous sûr de vouloir quitter la pop-up sans enregistrer vos modifications ?"
      )
    ) {
      setDialogVisibility(false);
      setUnsaved(false);
    }
  };

  const saveData = () => {
    if(type === "codeparsed") {
      try {
        const dataParsed = JSON.parse(codeEditorValue)
        onChange(dataParsed)
        setIncorrectDefaultValue(false)
        setDialogVisibility(false);
        setUnsaved(false);
      } catch {
        dispatch(setToast({
          content: "La valeur fournie n'est pas dans un format JSON correct, Merci de vérifier et réessayer",
          life: 5000,
          severity: 'error',
          title:"Erreur"
        }))
      }
    } else {
      onChange(codeEditorValue);
      setIncorrectDefaultValue(false)
      setDialogVisibility(false);
      setUnsaved(false);

    }
  }

  return (
    <div>
      <Dialog
        header={header}
        visible={dialogVisibility}
        className={"app-dialog"}
        onHide={() => {
          if (unsaved) {
            confirmDialog();
          } else {
            setDialogVisibility(false);
            setUnsaved(false);
          }
        }}
        footer={footer}
      >
        <CodeEditor
          defaultValue={codeEditorValue}
          lang={lang}
          valueUpdated={(value) => {
            setCodeEditorValue(value);
            setUnsaved(true);
          }}
        />
      </Dialog>
      <ErrorDefaultValueWidget displayError={incorrectDefaultValue} ></ErrorDefaultValueWidget>
      <Button
        label={"Editer"}
        disabled={disabled}
        onClick={() => setDialogVisibility(true)}
        className="mr-3 p-button-outlined p-button-sm"
      />
    </div>
  );
};
